import { createReducer, on } from '@ngrx/store';
import * as MarketingActions from './marketing.actions';
import { MarketingReportResponse, LeadMagnetResponse } from '../../services/marketing.service';

export interface MarketingState {
  report: MarketingReportResponse | null;
  loading: boolean;
  error: any;
  leadMagnet: {
    response: LeadMagnetResponse | null;
    loading: boolean;
    error: any;
  };
}

export const initialState: MarketingState = {
  report: null,
  loading: false,
  error: null,
  leadMagnet: {
    response: null,
    loading: false,
    error: null
  }
};

export const marketingReducer = createReducer(
  initialState,

  on(MarketingActions.loadMarketingReport, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(MarketingActions.loadMarketingReportSuccess, (state, { report }) => ({
    ...state,
    report,
    loading: false,
    error: null
  })),

  on(MarketingActions.loadMarketingReportFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  on(MarketingActions.clearMarketingReport, state => ({
    ...initialState
  })),

  on(MarketingActions.registerLeadMagnet, state => ({
    ...state,
    leadMagnet: {
      ...state.leadMagnet,
      loading: true,
      error: null
    }
  })),

  on(MarketingActions.registerLeadMagnetSuccess, (state, { response }) => ({
    ...state,
    leadMagnet: {
      response,
      loading: false,
      error: null
    }
  })),

  on(MarketingActions.registerLeadMagnetFailure, (state, { error }) => ({
    ...state,
    leadMagnet: {
      ...state.leadMagnet,
      loading: false,
      error
    }
  })),

  on(MarketingActions.clearLeadMagnetState, state => ({
    ...state,
    leadMagnet: {
      response: null,
      loading: false,
      error: null
    }
  }))
);